<template>
  <SidebarCard :header="$t('tbs_home_hotelier_hub')">
    <ul class="tw:flex tw:flex-col tw:gap-y-1">
      <li
        v-for="item in links"
        :key="item.id"
        class="tw:font-bold tw:text-blue-700 tw:hover:cursor-pointer tw:hover:underline"
      >
        <button @click="redirectToUrl($t(item.label), item.link)" class="tw:hover:cursor-pointer tw:hover:underline">
          {{ $t(item.label) }}
        </button>
      </li>
    </ul>
  </SidebarCard>
</template>
<script setup>
import { computed } from 'vue'

import SidebarCard from '@/components/homePage/sidebar/SidebarCard.vue'

import appAnalytics from '@/utils/tracking'

import { getContactUrl, getSupportCenterUrl } from '@/utils/Utility.ts'
import { selectedAccommodationId } from '@/layouts/queries'
import { useCampaign } from '@/components/rateConnect/queries'
import { useStudioPlusCampaign } from '@/components/payment/queries'
import { useSessionValues } from '@/composables/useSessionValues'

const { language, userId } = useSessionValues()
const { campaignsData } = useCampaign(selectedAccommodationId)
const { studioPlusCampaign } = useStudioPlusCampaign(selectedAccommodationId)
const isPaidClient = computed(
  () =>
    Boolean(studioPlusCampaign.value) ||
    (Array.isArray(campaignsData.value) ? campaignsData.value.length > 0 : Boolean(campaignsData.value))
)

const links = computed(() => {
  return [
    {
      id: 0,
      label: 'hotelier_support_homepage',
      link: getSupportCenterUrl(language.value),
    },
    { id: 1, label: 'navigation_menu_resources', link: 'https://www.businessblog-trivago.com/' },
    {
      id: 2,
      label: 'navigation_menu_contact_us',
      link: getContactUrl(language.value, userId.value, selectedAccommodationId.value, isPaidClient.value),
    },
  ]
})

const redirectToUrl = (buttonLabel, link) => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_SIDEBAR_HOTELIER_HUB, {
    accommodationId: selectedAccommodationId.value,
    item: buttonLabel,
  })
  window.open(link, '_blank')
}
</script>
